/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Gutachten } from '../models/gutachten';
import { FairAppSimpleRequest } from '../models/fair-app-simple-request';
import { KalkulationVorlage } from '../models/kalkulation-vorlage';
import { KalkulationGutachtenPosition } from '../models/kalkulation-gutachten-position';
import { FairAppIdRequest } from '../models/fair-app-id-request';
import { FairAppSimplestRequest } from '../models/fair-app-simplest-request';
import { GutachtenListRetrieve } from '../models/gutachten-list-retrieve';
import { GutachtenRequest } from '../models/gutachten-request';
import { FairAppOdataAktRequest } from '../models/fair-app-odata-akt-request';
import { KalkulationPdfRequest } from '../models/kalkulation-pdf-request';
import { OdataGutachtenPositionBatchPost } from '../models/odata-gutachten-position-batch-post';
import { OdataGutachtenPositionBatchPatch } from '../models/odata-gutachten-position-batch-patch';
import { OdataGutachtenPositionPost } from '../models/odata-gutachten-position-post';
import { OdataGutachtenPosition } from '../models/odata-gutachten-position';
import { OdataGutachtenPositionPatchPost } from '../models/odata-gutachten-position-patch-post';
import { OdataGutachten } from '../models/odata-gutachten';
import { OdataGutachtenPatchPost } from '../models/odata-gutachten-patch-post';
@Injectable({
  providedIn: 'root',
})
class GutachtenService extends __BaseService {
  static readonly gutachtenCreateCreatePath = '/gutachten/create';
  static readonly gutachtenKalkulationVorlageCreateCreatePath = '/gutachten/kalkulation/vorlage/create';
  static readonly gutachtenKalkulationVorlageDeleteCreatePath = '/gutachten/kalkulation/vorlage/delete';
  static readonly gutachtenKalkulationVorlageListCreatePath = '/gutachten/kalkulation/vorlage/list';
  static readonly gutachtenKalkulationVorlageUpdateCreatePath = '/gutachten/kalkulation/vorlage/update';
  static readonly gutachtenListRetrieveCreatePath = '/gutachten/list/retrieve';
  static readonly gutachtenOdataBerichtPdfCreatePath = '/gutachten/odata/bericht/pdf';
  static readonly gutachtenOdataBerichtUebergabeCreatePath = '/gutachten/odata/bericht/uebergabe';
  static readonly gutachtenOdataCloneCreatePath = '/gutachten/odata/clone';
  static readonly gutachtenOdataKalkulationPdfCreatePath = '/gutachten/odata/kalkulation/pdf';
  static readonly gutachtenOdataPositionBatchCreateCreatePath = '/gutachten/odata/position/batch/create';
  static readonly gutachtenOdataPositionBatchUpdateCreatePath = '/gutachten/odata/position/batch/update';
  static readonly gutachtenOdataPositionCreateCreatePath = '/gutachten/odata/position/create';
  static readonly gutachtenOdataPositionDeleteCreatePath = '/gutachten/odata/position/delete';
  static readonly gutachtenOdataPositionListCreatePath = '/gutachten/odata/position/list';
  static readonly gutachtenOdataPositionRetrieveCreatePath = '/gutachten/odata/position/retrieve';
  static readonly gutachtenOdataPositionUpdateCreatePath = '/gutachten/odata/position/update';
  static readonly gutachtenOdataRetrieveCreatePath = '/gutachten/odata/retrieve';
  static readonly gutachtenOdataStundenaufstellungPdfCreatePath = '/gutachten/odata/stundenaufstellung/pdf';
  static readonly gutachtenOdataUpdateCreatePath = '/gutachten/odata/update';
  static readonly gutachtenPositionCreateCreatePath = '/gutachten/position/create';
  static readonly gutachtenPositionDeleteCreatePath = '/gutachten/position/delete';
  static readonly gutachtenPositionListCreatePath = '/gutachten/position/list';
  static readonly gutachtenPositionUpdateCreatePath = '/gutachten/position/update';
  static readonly gutachtenRetrieveCreatePath = '/gutachten/retrieve';
  static readonly gutachtenSaveCreatePath = '/gutachten/save';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param data undefined
   */
  gutachtenCreateCreateResponse(data: FairAppSimpleRequest): __Observable<__StrictHttpResponse<Gutachten>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Gutachten>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenCreateCreate(data: FairAppSimpleRequest): __Observable<Gutachten> {
    return this.gutachtenCreateCreateResponse(data).pipe(
      __map(_r => _r.body as Gutachten)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenKalkulationVorlageCreateCreateResponse(data: KalkulationVorlage): __Observable<__StrictHttpResponse<KalkulationVorlage>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/kalkulation/vorlage/create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KalkulationVorlage>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenKalkulationVorlageCreateCreate(data: KalkulationVorlage): __Observable<KalkulationVorlage> {
    return this.gutachtenKalkulationVorlageCreateCreateResponse(data).pipe(
      __map(_r => _r.body as KalkulationVorlage)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenKalkulationVorlageDeleteCreateResponse(data: FairAppIdRequest): __Observable<__StrictHttpResponse<KalkulationGutachtenPosition>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/kalkulation/vorlage/delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KalkulationGutachtenPosition>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenKalkulationVorlageDeleteCreate(data: FairAppIdRequest): __Observable<KalkulationGutachtenPosition> {
    return this.gutachtenKalkulationVorlageDeleteCreateResponse(data).pipe(
      __map(_r => _r.body as KalkulationGutachtenPosition)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenKalkulationVorlageListCreateResponse(data: FairAppSimplestRequest): __Observable<__StrictHttpResponse<Array<KalkulationVorlage>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/kalkulation/vorlage/list`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<KalkulationVorlage>>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenKalkulationVorlageListCreate(data: FairAppSimplestRequest): __Observable<Array<KalkulationVorlage>> {
    return this.gutachtenKalkulationVorlageListCreateResponse(data).pipe(
      __map(_r => _r.body as Array<KalkulationVorlage>)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenKalkulationVorlageUpdateCreateResponse(data: KalkulationVorlage): __Observable<__StrictHttpResponse<KalkulationVorlage>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/kalkulation/vorlage/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KalkulationVorlage>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenKalkulationVorlageUpdateCreate(data: KalkulationVorlage): __Observable<KalkulationVorlage> {
    return this.gutachtenKalkulationVorlageUpdateCreateResponse(data).pipe(
      __map(_r => _r.body as KalkulationVorlage)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenListRetrieveCreateResponse(data: FairAppSimpleRequest): __Observable<__StrictHttpResponse<GutachtenListRetrieve>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/list/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GutachtenListRetrieve>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenListRetrieveCreate(data: FairAppSimpleRequest): __Observable<GutachtenListRetrieve> {
    return this.gutachtenListRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as GutachtenListRetrieve)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenOdataBerichtPdfCreateResponse(data: GutachtenRequest): __Observable<__StrictHttpResponse<GutachtenRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/odata/bericht/pdf`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GutachtenRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenOdataBerichtPdfCreate(data: GutachtenRequest): __Observable<GutachtenRequest> {
    return this.gutachtenOdataBerichtPdfCreateResponse(data).pipe(
      __map(_r => _r.body as GutachtenRequest)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenOdataBerichtUebergabeCreateResponse(data: GutachtenRequest): __Observable<__StrictHttpResponse<GutachtenRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/odata/bericht/uebergabe`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GutachtenRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenOdataBerichtUebergabeCreate(data: GutachtenRequest): __Observable<GutachtenRequest> {
    return this.gutachtenOdataBerichtUebergabeCreateResponse(data).pipe(
      __map(_r => _r.body as GutachtenRequest)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenOdataCloneCreateResponse(data: FairAppOdataAktRequest): __Observable<__StrictHttpResponse<Gutachten>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/odata/clone`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Gutachten>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenOdataCloneCreate(data: FairAppOdataAktRequest): __Observable<Gutachten> {
    return this.gutachtenOdataCloneCreateResponse(data).pipe(
      __map(_r => _r.body as Gutachten)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenOdataKalkulationPdfCreateResponse(data: KalkulationPdfRequest): __Observable<__StrictHttpResponse<KalkulationPdfRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/odata/kalkulation/pdf`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KalkulationPdfRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenOdataKalkulationPdfCreate(data: KalkulationPdfRequest): __Observable<KalkulationPdfRequest> {
    return this.gutachtenOdataKalkulationPdfCreateResponse(data).pipe(
      __map(_r => _r.body as KalkulationPdfRequest)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenOdataPositionBatchCreateCreateResponse(data: OdataGutachtenPositionBatchPost): __Observable<__StrictHttpResponse<Array<KalkulationGutachtenPosition>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/odata/position/batch/create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<KalkulationGutachtenPosition>>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenOdataPositionBatchCreateCreate(data: OdataGutachtenPositionBatchPost): __Observable<Array<KalkulationGutachtenPosition>> {
    return this.gutachtenOdataPositionBatchCreateCreateResponse(data).pipe(
      __map(_r => _r.body as Array<KalkulationGutachtenPosition>)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenOdataPositionBatchUpdateCreateResponse(data: OdataGutachtenPositionBatchPatch): __Observable<__StrictHttpResponse<Array<KalkulationGutachtenPosition>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/odata/position/batch/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<KalkulationGutachtenPosition>>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenOdataPositionBatchUpdateCreate(data: OdataGutachtenPositionBatchPatch): __Observable<Array<KalkulationGutachtenPosition>> {
    return this.gutachtenOdataPositionBatchUpdateCreateResponse(data).pipe(
      __map(_r => _r.body as Array<KalkulationGutachtenPosition>)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenOdataPositionCreateCreateResponse(data: OdataGutachtenPositionPost): __Observable<__StrictHttpResponse<KalkulationGutachtenPosition>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/odata/position/create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KalkulationGutachtenPosition>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenOdataPositionCreateCreate(data: OdataGutachtenPositionPost): __Observable<KalkulationGutachtenPosition> {
    return this.gutachtenOdataPositionCreateCreateResponse(data).pipe(
      __map(_r => _r.body as KalkulationGutachtenPosition)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenOdataPositionDeleteCreateResponse(data: FairAppOdataAktRequest): __Observable<__StrictHttpResponse<FairAppOdataAktRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/odata/position/delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FairAppOdataAktRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenOdataPositionDeleteCreate(data: FairAppOdataAktRequest): __Observable<FairAppOdataAktRequest> {
    return this.gutachtenOdataPositionDeleteCreateResponse(data).pipe(
      __map(_r => _r.body as FairAppOdataAktRequest)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenOdataPositionListCreateResponse(data: GutachtenRequest): __Observable<__StrictHttpResponse<Array<KalkulationGutachtenPosition>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/odata/position/list`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<KalkulationGutachtenPosition>>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenOdataPositionListCreate(data: GutachtenRequest): __Observable<Array<KalkulationGutachtenPosition>> {
    return this.gutachtenOdataPositionListCreateResponse(data).pipe(
      __map(_r => _r.body as Array<KalkulationGutachtenPosition>)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenOdataPositionRetrieveCreateResponse(data: FairAppOdataAktRequest): __Observable<__StrictHttpResponse<OdataGutachtenPosition>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/odata/position/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataGutachtenPosition>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenOdataPositionRetrieveCreate(data: FairAppOdataAktRequest): __Observable<OdataGutachtenPosition> {
    return this.gutachtenOdataPositionRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as OdataGutachtenPosition)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenOdataPositionUpdateCreateResponse(data: OdataGutachtenPositionPatchPost): __Observable<__StrictHttpResponse<KalkulationGutachtenPosition>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/odata/position/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KalkulationGutachtenPosition>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenOdataPositionUpdateCreate(data: OdataGutachtenPositionPatchPost): __Observable<KalkulationGutachtenPosition> {
    return this.gutachtenOdataPositionUpdateCreateResponse(data).pipe(
      __map(_r => _r.body as KalkulationGutachtenPosition)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenOdataRetrieveCreateResponse(data: FairAppOdataAktRequest): __Observable<__StrictHttpResponse<OdataGutachten>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/odata/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataGutachten>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenOdataRetrieveCreate(data: FairAppOdataAktRequest): __Observable<OdataGutachten> {
    return this.gutachtenOdataRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as OdataGutachten)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenOdataStundenaufstellungPdfCreateResponse(data: GutachtenRequest): __Observable<__StrictHttpResponse<GutachtenRequest>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/odata/stundenaufstellung/pdf`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GutachtenRequest>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenOdataStundenaufstellungPdfCreate(data: GutachtenRequest): __Observable<GutachtenRequest> {
    return this.gutachtenOdataStundenaufstellungPdfCreateResponse(data).pipe(
      __map(_r => _r.body as GutachtenRequest)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenOdataUpdateCreateResponse(data: OdataGutachtenPatchPost): __Observable<__StrictHttpResponse<OdataGutachten>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/odata/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OdataGutachten>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenOdataUpdateCreate(data: OdataGutachtenPatchPost): __Observable<OdataGutachten> {
    return this.gutachtenOdataUpdateCreateResponse(data).pipe(
      __map(_r => _r.body as OdataGutachten)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenPositionCreateCreateResponse(data: KalkulationGutachtenPosition): __Observable<__StrictHttpResponse<KalkulationGutachtenPosition>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/position/create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KalkulationGutachtenPosition>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenPositionCreateCreate(data: KalkulationGutachtenPosition): __Observable<KalkulationGutachtenPosition> {
    return this.gutachtenPositionCreateCreateResponse(data).pipe(
      __map(_r => _r.body as KalkulationGutachtenPosition)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenPositionDeleteCreateResponse(data: FairAppIdRequest): __Observable<__StrictHttpResponse<KalkulationGutachtenPosition>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/position/delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KalkulationGutachtenPosition>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenPositionDeleteCreate(data: FairAppIdRequest): __Observable<KalkulationGutachtenPosition> {
    return this.gutachtenPositionDeleteCreateResponse(data).pipe(
      __map(_r => _r.body as KalkulationGutachtenPosition)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenPositionListCreateResponse(data: FairAppSimplestRequest): __Observable<__StrictHttpResponse<Array<KalkulationGutachtenPosition>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/position/list`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<KalkulationGutachtenPosition>>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenPositionListCreate(data: FairAppSimplestRequest): __Observable<Array<KalkulationGutachtenPosition>> {
    return this.gutachtenPositionListCreateResponse(data).pipe(
      __map(_r => _r.body as Array<KalkulationGutachtenPosition>)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenPositionUpdateCreateResponse(data: KalkulationGutachtenPosition): __Observable<__StrictHttpResponse<KalkulationGutachtenPosition>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/position/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KalkulationGutachtenPosition>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenPositionUpdateCreate(data: KalkulationGutachtenPosition): __Observable<KalkulationGutachtenPosition> {
    return this.gutachtenPositionUpdateCreateResponse(data).pipe(
      __map(_r => _r.body as KalkulationGutachtenPosition)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenRetrieveCreateResponse(data: GutachtenRequest): __Observable<__StrictHttpResponse<Gutachten>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/retrieve`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Gutachten>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenRetrieveCreate(data: GutachtenRequest): __Observable<Gutachten> {
    return this.gutachtenRetrieveCreateResponse(data).pipe(
      __map(_r => _r.body as Gutachten)
    );
  }

  /**
   * @param data undefined
   */
  gutachtenSaveCreateResponse(data: Gutachten): __Observable<__StrictHttpResponse<Gutachten>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = data;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gutachten/save`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Gutachten>;
      })
    );
  }
  /**
   * @param data undefined
   */
  gutachtenSaveCreate(data: Gutachten): __Observable<Gutachten> {
    return this.gutachtenSaveCreateResponse(data).pipe(
      __map(_r => _r.body as Gutachten)
    );
  }
}

module GutachtenService {
}

export { GutachtenService }
